import React, { useContext, useEffect, useRef, useState } from "react";
import "./UserProfile.css";
import { toast } from "react-toastify";
import { API } from "../../constants/Api";
import { ProfileUpdate } from "../../App";

function ChangePassword() {
  const [image, setImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const token = localStorage.getItem("token");
  const imageRef = useRef(null);
  const [userEmail, setEmail] = useState("");
  const [userPhone, setPhone] = useState("");
  const userId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { profileUpdateState, setProfileUpdateState } =
    useContext(ProfileUpdate);

  const [update, setUpdate] = useState(0);

  useEffect(() => {
    const getUserInfo = async () => {
      try {
        const response = await fetch(`${API}/users/single-user/${userId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const json = await response.json();

        if (response.ok) {
          setEmail(json.data.email);
          setPhone(json.data.phonenumber);

          setPreviewImage(json.data.imageUrl);
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    getUserInfo();
  }, [update]);
  const handleImageButton = () => {
    if (imageRef) {
      imageRef.current.click();
    }
  };
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size / 2000000 > 1) {
        toast.error("Profile image should be less than 2 MB");
      } else {
        setImage(file);
        setPreviewImage(URL.createObjectURL(file));
      }
    }
  };
  function validation() {
    if (userEmail.length < 1) {
      toast.error("Email is required");
      return false;
    }
    if (userPhone.length < 1) {
      toast.error("Phone number required");
      return false;
    }
    if (password.length > 1) {
      if (password !== confirmPassword) {
        toast.error("Passwords does not match");
        return false;
      }
    }
    if (userPhone.length > 10) {
      toast.error("Phone length should be under 11");
      return false;
    }

    return true;
  }

  const handleSignUp = async (e) => {
    e.preventDefault();

    const validate = await validation();

    if (validate) {
      const formData = new FormData();

      formData.append("email", userEmail);
      formData.append("phonenumber", userPhone);
      if (image) {
        formData.append("image", image);
      }
      if (password.length > 1) {
        formData.append("password", password);
      }
      setLoading(true);
      const toastLoading = await toast.loading("Updating info...");
      try {
        const response = await fetch(`${API}/users/update-user/${userId}`, {
          method: "PUT",
          body: formData,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const json = await response.json();
        if (response.ok) {
          toast.dismiss(toastLoading);
          toast.success("Information updated seccessfully");
          setLoading(false);

          setUpdate(update + 1);
          setProfileUpdateState(profileUpdateState + 1);
        } else {
          setLoading(false);
          toast.dismiss(toastLoading);
          toast.error(json.message);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        toast.dismiss(toastLoading);
        setLoading(false);

        setImage(null);
      }
    }
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="user-profile">
      <h2 className="user-layout-page-heading">Profile Settings</h2>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 px-0 pt-3">
            <p className="user-profile-picture">Profile Picture</p>
          </div>
          <div className="col-12 px-0">
            <div className="user-profile-box">
              <div className="user-profile-image">
                {previewImage ? (
                  <img
                    src={previewImage}
                    className="user-layout-content-header-image-media"
                    alt=""
                  />
                ) : (
                  <></>
                )}
              </div>
              <div className="user-profile-details">
                <button
                  onClick={handleImageButton}
                  className="btn logout-button"
                >
                  Change Profile Picture
                </button>
                <input
                  type="file"
                  hidden
                  onChange={handleImageChange}
                  ref={imageRef}
                  accept="image/png, image/jpeg, image/jpg"
                />
              </div>
            </div>
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>
          <div className="col-lg-7 px-0 py-1">
            <p className="user-profile-picture">Account Details</p>

            <input
              type="email"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Email address"
              value={userEmail}

              // onChange={(e) => setEmail(e.target.value)}
            />
            {isMobile ? (
              <input
                type="tel"
                className="form-control user-profile-input-field"
                id="userPhone"
                placeholder="Phone number"
                value={`+1 ${userPhone}`} // Display "+1" prefix
                onChange={(e) => {
                  // Remove "+1" and any extra spaces before saving to state
                  const rawNumber = e.target.value.replace(/^\+1\s*/, "");
                  setPhone(rawNumber);
                }}
              />
            ) : (
              <div className="user-profile-phone-number-group">
                <button className="user-profile-phone-code">+1</button>
                <input
                  type="number"
                  className="form-control user-profile-phone-field"
                  id="exampleInputPassword1"
                  placeholder="Phone Number"
                  value={userPhone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            )}
          </div>
          <div className="col-12 px-0 py-1">
            <hr className="text-white" style={{ opacity: "0.05" }} />
          </div>

          <div className="col-md-7 px-0 py-1">
            <p className="user-profile-picture">New Password</p>
            <input
              type="password"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="New Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="col-md-7 px-0 py-3">
            <p className="user-profile-picture">Confirm Password</p>
            <input
              type="password"
              className="form-control user-profile-input-field"
              id="exampleInputPassword1"
              placeholder="Confirm Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
       
            {loading ? (
              <div className="col-md-7 px-0 py-3">
                <button className="btn user-profile-update-button">
                  processing...
                </button>
              </div>
            ) : (
              <div className="col-md-7 px-0 py-3">
                <button
                  onClick={handleSignUp}
                  className="btn user-profile-update-button"
                >
                  Update
                </button>
              </div>
            )}
     
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;
